export const contactsTableColumns = [
  {
    title: "Id",
    dataIndex: "id",
    key: "id",
    width: "60px",
    slots: { customRender: "id" },
  },
  {
    title: "Cod Contacto",
    dataIndex: "code_client",
    key: "code_client",
    width: "140px",
    slots: { customRender: "code_client" },
  },
  {
    title: "Nombres de contacto",
    dataIndex: "full_name",
    key: "full_name",
    width: "200px",
    ellipsis: true,
    slots: { customRender: "full_name" },
  },
  {
    title: "Fecha de asignación",
    dataIndex: "created_at",
    key: "created_at",
    width: "170px",
  },
  {
    title: "Estado",
    dataIndex: "state",
    key: "state",
    width: "120px",
  },
  {
    title: "Acción",
    dataIndex: "action",
    key: "action",
    width: "120px",
  },
];
